import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ChatStateService } from 'src/app/services/chat-state/chat-state.service';

/**
 * The way in to the AI chat from the rest of the app: a link to the chat page, or a box to
 * ask a first question in, which opens the chat page on the conversation it starts.
 */
@Component({
    selector: 'app-ai-global',
    templateUrl: './ai-global.component.html',
    styleUrls: ['./ai-global.component.scss'],
})
export class AIGlobalComponent {
    userInput: string = '';
    @Input() useTextEntry: boolean = true;

    constructor(
        private chatState: ChatStateService,
        private router: Router,
    ) { }

    ask() {
        const thread = this.chatState.ask(this.userInput);
        if (thread) {
            this.userInput = '';
            this.router.navigate(['/chat', thread]);
        }
    }
}
